/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLoader = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 5a7.003 7.003 0 0 1 6.93 6H22v2h-3.071a7.003 7.003 0 0 1-11.826 4.001L2 17v-2h3.674a6.95 6.95 0 0 1-.603-2H2v-2h3.07a6.95 6.95 0 0 1 .604-2H2V7h5.102A6.977 6.977 0 0 1 12 5zm0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLoader as Loader };
